import {
  PartialSanityImageType,
  ResponsiveSanityImage
} from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./SectionSliderCard.module.scss";
import { WrapWithLink } from "components/WrapWithLink";

type Props = {
  image?: PartialSanityImageType;
  trackingName?: string;
  url?: string;
  alt?: string;
};

const SectionSliderCard: React.FC<Props> = ({
  image,
  url,
  trackingName,
  alt
}) => {
  return (
    <div
      className={styles.cardContent}
      data-content-name={trackingName}
      suppressHydrationWarning
    >
      <WrapWithLink href={url} data-content-piece="image">
        <ResponsiveSanityImage
          image={image}
          defaultWidth={600}
          defaultHeight={400}
          alt={alt}
        />
      </WrapWithLink>
    </div>
  );
};

export default SectionSliderCard;
